<template>
  <div>
    <Header v-if="this.userInfo.user.permission == 'super_admin'" />

    <HodHeader v-if="this.userInfo.user.permission == 'hod'" />
    <CoordinateHeader v-if="this.userInfo.user.permission == 'co-ordinator'" />
    <InstructorHeader v-if="this.userInfo.user.permission == 'instructor'" />

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <confirmPopup
      v-if="popupwindow == true"
      :title="titlepass"
      @cancelClick="popupwindow = false"
      @confirmClick="deletecourse(idpass)"
    />

    <div class="py-10 max-h-screen overflow-y-auto">
      <div class="container mx-auto max-w-[1200px] flex flex-col gap-10 px-6">
        <div
          class="flex flex-col md:flex-col justify-between lg:flex-row items-start gap-4"
        >
          <h1 class="text-2xl font-bold text-primary text-start md:text-left">
            My Courses 
          </h1>

          <div
            class="flex flex-col gap-4 md:flex-row md:items-center md:justify-between flex-wrap"
          >
            <!-- Filter Dropdown -->
            <div>
              <select
                name="model_select"
                id="model_select"
                v-model="selected_filter"
                @change="filterorder()"
                class="px-4 py-2 w-full md:w-[160px] rounded-xl text-sm text-white bg-blues font-semibold focus:outline-none focus:ring-2 focus:ring-blue-400 transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
              >
                <option value="" disabled selected>Select sorting</option>
                <option value="title">A to Z</option>
                <option value="-title">Z to A</option>
                <option value="created_at">New to Old</option>
                <option value="-created_at">Old to New</option>
              </select>
            </div>

            <!-- Action Buttons -->
            <div class="flex flex-wrap gap-2">
              <router-link
                v-if="this.userInfo.user.permission != 'instructor'"
                :to="{ name: 'AdminNewCourses' }"
                class="bg-blues text-white px-4 py-2 rounded-xl text-sm font-semibold shadow-md transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
              >
                Add New Course
              </router-link>

              <router-link
                :to="{ name: 'AdminStudentAssign' }"
                class="bg-blues text-white px-4 py-2 rounded-xl text-sm font-semibold shadow-md transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
              >
                Assign Student
              </router-link> 

              <!-- <router-link
                :to="{ name: 'AICourseCreate' }"
                class="border border-blues text-blues px-4 py-2 rounded-xl text-sm font-semibold shadow-md transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues"
              >
                AI Course Create
              </router-link> -->

            </div>

            <!-- Search Form -->
            <form
              @submit.prevent="getCourses(1)"
              class="w-full md:w-auto flex gap-2 items-center"
            >
              <div
                class="flex w-full md:w-[300px] rounded-xl overflow-hidden"
                style="box-shadow: 0px 2px 20px 0px #105c8e26"
              >
                <input
                  type="text"
                  name="search"
                  id="search"
                  v-model="search_list"
                  @input="getCourses(1)"
                  placeholder="Search The Course"
                  class="flex-1 px-4 py-2 outline-none text-sm text-gray-700"
                />
                <button
                  type="submit"
                  :disabled="disable_submit == true"
                  :class="
                    this.disable_submit == true
                      ? 'bg-gray-200 text-black cursor-not-allowed'
                      : 'bg-blues hover:bg-[#18469d] cursor-pointer'
                  "
                  class="px-4 flex items-center justify-center"
                >
                  <img
                    src="@/assets/search.webp"
                    alt="Search"
                    class="w-5 h-5"
                  />
                </button>
              </div>
              <img
                v-if="disable_submit"
                src="@/assets/loading.gif"
                alt="loading"
                class="w-6 h-6 object-contain"
              />
            </form>
          </div>
        </div>

        <h1 class="text-lg font-bold text-primary text-start md:text-left">
          Total: {{ course_count || 0 }}
        </h1>

        <div>
          <div class="grid grid-cols-1 md:grid-cols-6 gap-5">
            <!-- <h3 class="font-semibold mb-2">Input Group {{ index + 1 }}</h3> -->
            <!-- Program Name -->

            <select
              id="program_id"
              @change="
                getCourses(1);
                getProgramsFilter();
              "
              required
              class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold capitalize leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:bg-gray-100"
            >
              <option value="" disabled selected>Select Program</option>
              <option
                v-for="program in programs"
                :key="program.id"
                :value="program.id"
              >
                {{ program.name }}
              </option>
            </select>
            <!-- department -->
            <select
              id="department_id"
              @change="
                getCourses(1);
                getSemesterFilter();
              "
              required
              class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold capitalize leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 hover:bg-gray-100"
            >
              <option value="" disabled selected>Select Department</option>
              <option
                v-for="department in departments"
                :key="department.id"
                :value="department.id"
              >
                {{ department.name }}
              </option>
            </select>

            <!-- Semester -->

            <select
              id="semester_id"
              @change="
                getCourses(1);
                sectionsGet();
              "
              required
              class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold capitalize leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 hover:bg-gray-100"
            >
              <option value="" disabled selected>Select Semester</option>
              <option
                v-for="semester in semetser_list"
                :key="semester.id"
                :value="semester.id"
              >
                {{ semester.semester }}
              </option>
            </select>

            <!-- Section -->

            <select
              id="section_id"
              @change="
                getCourses(1);
                coursetypeGet();
              "
              required
              class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold capitalize leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 hover:bg-gray-100"
            >
              <option value="" disabled selected>Select Section</option>
              <option
                v-for="section in sections"
                :key="section.name"
                :value="section.name"
              >
                {{ section.name }}
              </option>
            </select>

            <!-- course type -->

            <select
              id="coursetype_id"
              @change="
                getCourses(1);
                instructorGet();
              "
              required
              class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold capitalize leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 hover:bg-gray-100"
            >
              <option value="" disabled selected>Select Course type</option>
              <option
                v-for="course_type in course_types"
                :key="course_type.title"
                :value="course_type.title"
              >
                {{ course_type.title }}
              </option>
            </select>

            <!-- instructor email -->

            <select
              id="instructor_id"
              @change="getCourses(1)"
              required
              class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold capitalize leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 hover:bg-gray-100"
            >
              <option value="" disabled selected>
                Select instructor email
              </option>
              <option
                v-for="instructor in instructor_list"
                :key="instructor.email"
                :value="instructor.email"
              >
                {{ instructor.email }}
              </option>
            </select>

            <!-- instructor name -->

            <select
              id="instructor_name"
              @change="getCourses(1)"
              required
              class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold capitalize leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 hover:bg-gray-100"
            >
              <option value="" disabled selected>Select instructor name</option>
              <option
                v-for="instructor in instructor_list"
                :key="instructor.display_name"
                :value="instructor.display_name"
              >
                {{ instructor.display_name }}
              </option>
            </select>

            <button
              type="button"
              @click="clearFilters"
              class="text-blue-600 underline flex items-center text-xs font-semibold gap-1 hover:text-blues"
            >
              <img
                src="@/assets/attendance/cancel.webp"
                alt="Clear"
                class="w-3 h-3 object-contain"
              />
              Clear All
            </button>
            <!-- Section -->
            <!-- <div class="flex flex-col gap-3">
                  <label class="text-sm">Section</label>
                  <select
                    id="section_id"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3"
                  >
                    <option value="" disabled>Select Section</option>
                    <option
                      v-for="section in sections"
                      :key="section.id"
                      :value="section.id"
                    >
                      {{ section.name }}
                    </option>
                  </select>
                </div> -->

            <!-- Faculty -->
            <!-- <div class="flex flex-col gap-3">
                  <label class="text-sm">Select Faculty</label>
                  <select
                    id="instructor_id"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3"
                  >
                    <option value="" disabled>Select Faculty</option>
                    <option
                      v-for="instructor in instructor_lists"
                      :key="instructor.id"
                      :value="instructor.id"
                    >
                      {{ instructor.user.email }}
                    </option>
                  </select>
                </div> -->
          </div>
        </div>

        <div
          v-if="loading"
          class="flex items-center justify-center h-[calc(100vh-350px)]"
        >
          <img src="@/assets/newd/loading.gif" alt="Loading" />
        </div>
        <div v-else>
          <div  v-if="courselist.length > 0">
          <div
           
            class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-10"
          >
            <div
              class="rounded-3xl shadow-md"
              v-for="course in courselist"
              :key="course"
            >
              <div
                class="flex flex-col h-full justify-between text-start sm:text-left px-4 sm:px-6 py-6"
              >
                <router-link
                  :to="{
                    name: 'InstructorStudents',
                    params: {
                      course_id: course.id,
                      department_id: course.department.id,
                    },
                  }"
                  class="flex flex-col gap-1 min-h-[300px]"
                >
                  <img
                    v-if="course.thumbnail"
                    class="object-cover object-center h-[200px] w-full rounded-lg"
                    :src="course.thumbnail"
                    alt="Course Thumbnail"
                  />
                  <img
                    v-else
                    class="object-cover object-center h-[200px] w-full rounded-lg"
                    src="@/assets/coding.svg"
                    alt="Default Thumbnail"
                  />

                  <!-- <div class="flex flex-col justify-between">  -->

                  <h1 class="font-bold text-lg text-primary py-2">
                    {{ course.title.slice(0, 50) }}
                    <p
                      v-if="course.title.length > 50"
                      class="text-primary text-sm mt-1 font-semibold"
                    >
                      ...More
                    </p>
                  </h1>

                  <div class="flex flex-col gap-1">
                    <p class="text-sm">
                      <span class="font-semibold">Course Code:</span>
                      {{ course?.course_code || "NAN" }}
                    </p>

                    <p class="text-sm">
                      <span class="font-semibold">Program:</span>
                      {{ course?.program?.name || "NAN" }}
                    </p>
                    <p class="text-sm">
                      <span class="font-semibold">Department: </span
                      >{{ course?.department?.name || "NAN" }}
                    </p>
                    <p class="text-sm">
                      <span class="font-semibold">Semester: </span
                      >{{ course?.semester?.semester || "NAN" }}
                    </p>
                    <p class="text-sm">
                      <span class="font-semibold">Instructor Email:</span>
                      <span v-if="course.instructor.length > 0">
                        {{ course?.instructor[0].user.email }}
                      </span>
                      <span v-else>NAN</span>
                    </p>
                    <p class="text-sm">
                      <span class="font-semibold">Section:</span>
                      {{ course?.class_section || "NAN" }}
                    </p>
                    <p class="text-sm">
                      <span class="font-semibold">Course Type:</span>
                      {{ course?.course_type?.title || "NAN" }}
                    </p>
                    <p class="text-sm">
                      <span class="font-semibold">Instructor Name:</span>
                      <span v-if="course.instructor.length > 0">
                        {{ course.instructor[0].user.display_name }}
                      </span>
                      <span v-else>NAN</span>
                    </p>
                  </div>
                </router-link>

                <div
                  class="mb-5 mt-2 flex items-center gap-2 hidden"
                  v-if="
                    this.userInfo.user.permission == 'super_admin' ||
                    this.userInfo.user.permission == 'hod' ||
                    this.userInfo.user.permission == 'co-ordinator'
                  "
                >
                  <button
                    @click="changeInstructorPopup = course.id ;  findinstructor(course.id)"
                    class="text-xs cursor-pointer bg-blues text-white px-3 py-1 font-bold rounded-2xl transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
                  >
                    Change Instructor
                  </button>

                  <!--  -->
                  <router-link
                  :to="{
                    name: 'InstructorStudents',
                    params: {
                      course_id: course.id,
                      department_id: course.department.id,
                    },
                  }"
                    class="text-xs cursor-pointer bg-blues text-white px-3 py-1 font-bold rounded-2xl transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
                  >
                    Dashboard
                  </router-link>

                </div>

                <div class="flex items-center gap-10 mt-5">
                  <!-- <div @click="editCoursePopup = true; currentId = course.id">
                    <img src="@/assets/newd/icon2.svg" alt="Edit Course" />
                  </div> -->

                  <!-- <div
                    @click="
                      addLessonUnitPopup = true;
                      currentId = course.id;
                    "
                  >
                    <img src="@/assets/newd/icon1.svg" alt="Add Course" class=" cursor-pointer" />
                  </div> -->

                  <!-- AddLessonUnit -->

                  <router-link
                    :to="{
                      name: 'AddLessonUnit',
                      params: { course_id: course.id },
                    }"
                    class="flex flex-col gap-1"
                  >
                    <div class="relative group">
                      <img
                        src="@/assets/newd/icon1.svg"
                        alt="Add Course"
                        class="cursor-pointer"
                      />
                       <span
                              class="absolute top-8 z-40 left-1/2 transform -translate-x-1/2 bg-gray-700 text-white text-xs px-2 whitespace-nowrap py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity"
                            >
                              Add
                            </span>
                    </div>
                  </router-link>

                  <router-link
                    v-if="
                      this.userInfo.user.permission == 'super_admin' ||
                      this.userInfo.user.permission == 'hod' ||
                      this.userInfo.user.permission == 'co-ordinator'
                    "
                    :to="{
                      name: 'InstructorCourseEdit',
                      params: { course_id: course.id },
                    }"
                    class="flex flex-col gap-1"
                  >
                    <div class="relative group">
                      <img src="@/assets/newd/icon2.svg" alt="Edit Course" />
                      <span
                              class="absolute top-8 z-40 left-1/2 transform -translate-x-1/2 bg-gray-700 text-white text-xs px-2 whitespace-nowrap py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity"
                            >
                              Edit 
                            </span>
                    </div>
                  </router-link>

                  <div
                    @click="
                      titlepass = course.title;
                      popupwindow = true;
                      idpass = course.id;
                    "
                    class="cursor-pointer"
                    v-if="
                      this.userInfo.user.permission == 'super_admin' ||
                      this.userInfo.user.permission == 'hod' ||
                      this.userInfo.user.permission == 'co-ordinator'
                    "
                  >
                   <div class="relative group">
                    <img src="@/assets/newd/icon3.svg" alt="Delete Course" />
                    <span
                              class="absolute top-8 z-40 left-1/2 transform -translate-x-1/2 bg-gray-700 text-white text-xs px-2 whitespace-nowrap py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity"
                            >
                              Delete 
                            </span>
                    </div>
                  </div>

                  <router-link
                    :to="{
                      name: 'AdminCoursePreview',
                      params: { course_id: course.id },
                    }"
                    class="cursor-pointer bg-blues text-white px-3 py-1 text-sm font-bold rounded-2xl transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
                  >
                    Preview
                  </router-link>

                  <!-- <router-link
                    :to="{
                      name: 'AdminCoursePreview',
                      params: { course_id: course.id },
                    }"
                    class="cursor-pointer bg-blues text-white px-3 py-1 text-sm font-bold rounded-2xl transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
                  >
                    C
                  </router-link> -->
                </div> 

                <!-- DuplicateCourse -->
                <div class="mt-3"  v-if="
                      this.userInfo.user.permission == 'super_admin' ||
                      this.userInfo.user.permission == 'hod' ||
                      this.userInfo.user.permission == 'co-ordinator'
                    "> 
                  <button
                    @click="DuplicateCourse(course.id)"
                    class="cursor-pointer bg-blues text-white px-3 py-1 text-sm font-bold rounded-2xl transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
                  >
                    Duplicate
                  </button>
                </div>
              

                <!-- </div> -->
              </div>
            </div>
            
          </div>
          
 <Pagination
            :totalPages="totalPages"
            ref="paginationRef"
            @page-changed="this.getCourses"
          />
          </div>
         
          

          <div v-else class="text-lg font-normal text-center">
            No data Found
          </div>

          <!-- {{ pageArray }} -->
        </div>
      </div>
    </div>

    <div
      v-if="addLessonUnitPopup"
      class="fixed z-50 w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0"
    >
      <AddLessonUnit
        :course_id="currentId"
        @close-AddUnit="closeReciveEmitAddUnit"
      />
    </div>

    <div
      v-if="changeInstructorPopup != null"
      class="fixed z-50 w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex justify-center items-center"
    >
      <div
        class="container px-6 mx-auto max-w-[1200px] flex flex-col gap-10 my-10 pb-10"
      >
        <div class="pb-10">
          <form
            ref="changeInsRef"
            @submit.prevent="completeUnitStart"
            class="rounded-3xl py-10 px-10 pb-2 heightfix bg-white overflow-y-auto flex flex-col gap-5"
            style="box-shadow: 0px 2px 20px 0px #105c8e26"
          >
            <div class="flex items-center justify-end gap-4">
              <button
                @click="changeInstructorPopup = null"
                class="bg-blues text-xs font-bold text-white px-5 py-1.5 rounded-full cursor-pointer"
              >
                Close
              </button>
            </div>

            <div class="flex flex-col gap-3 hidden">
              <label class="text-sm">Select Faculty </label>
              <select
                id="instructor"
                class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3"
              >
                <option value="" disabled>Select Faculty</option>
                <option
                  v-for="instructor in instructor_lists"
                  :key="instructor.id"
                  :value="instructor.id"
                >
                  {{ instructor.user.email }}
                </option>
              </select>
            </div>

              <div class="flex flex-col gap-3 ">
        <label class="text-sm font-medium">Select Faculty</label>
        <ul
          class=" w-full border rounded-lg shadow-md h-[150px] overflow-y-auto mt-1 p-2 space-y-2"
           :class="instructor_lists.length === 0 ? 'bg-gray-200' : 'bg-white'"
        >
          <li
            v-for="instructor in instructor_lists"
            :key="instructor.id"
            class="flex items-center gap-2 cursor-pointer"
          >
            <input
              type="checkbox"
              :value="instructor.id"
             v-model="selectedInstructors"
              class="form-checkbox accent-blue-600"
            />
            <span>{{ instructor.user.email }}</span>
          </li>
        </ul>
      </div>

            <div class="pb-8 flex items-center gap-3">
              <button
                type="submit"
                :disabled="disable_submit == true"
                :class="
                  this.disable_submit == true
                    ? 'bg-gray-200 text-black cursor-not-allowed'
                    : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                "
                class="rounded-lg text-sm px-4 py-2"
              >
                Submit
              </button>
              <img
                v-if="disable_submit"
                src="@/assets/loading.gif"
                alt="loading"
                class="w-6 h-6 object-contain"
              />-->
            </div>
          </form>
        </div>
      </div>
      <!-- <AddLessonUnit
        :course_id="currentId"
        @close-AddUnit="closeReciveEmitAddUnit"
      /> -->
    </div>
  </div>
</template>

<script>
import Header from "@/components/Admin/Header.vue";
import HodHeader from "@/components/Hod/Header.vue";
import CoordinateHeader from "@/components/Coordinate/Header.vue";
import InstructorHeader from "@/components/Instructor/Header.vue";

import ConfirmPopup from "@/components/ConfirmPopup.vue";
import FlashMessage from "@/components/FlashMessage.vue";

import axios from "axios";
import { mapGetters } from "vuex";

import AddLessonUnit from "@/components/Common/AddLessonUnit.vue";
import Pagination from "@/components/Pagination.vue";

export default {
  components: {
    Header,
    FlashMessage,
    ConfirmPopup,
    AddLessonUnit,
    HodHeader,
    CoordinateHeader,
    InstructorHeader,
    Pagination,
  },

  data() {
    return {
      changeInstructorPopup: null,
      courselist: "",
      instructorInfo: "",
      messages: "",
      popupwindow: false,
      loading: true,
      search_list: "",
      currentId: null,
      addLessonUnitPopup: false,
      totalPages: 1,
      current_page: 1,
      pageSize: 5,
      pageArray: [],
      programs: [],
      departments: [],
      instructor_lists: [],
      semetser_list: [],
      sections: [],
      course_types: [],
      instructor_list: [],
      selected_filter: "",
      course_count: null,
      disable_submit: false,
      selectedInstructors:[],
    };
  },

  computed: {
    ...mapGetters(["userInfo"]),
   
  },

  watch: {
   
  },

  async created() {
    await axios
      .get(
        `${process.env.VUE_APP_API}/instructor/?Key=${this.userInfo.token_key}`
      )
      .then((response) => {
        this.instructorInfo = response.data;
        console.log(this.instructorInfo, "info");
      });

    this.getCourses(1);
    this.getPrograms();
    this.getInstructorList();
  },

  mounted() {},

  methods: {
     findinstructor(course_id){

      this.courselist.forEach((course)=>{

        if(course.id == course_id){
          this.selectedInstructors= course.instructor.map((instructor)=>instructor.id)
        }
      })
console.log("course_id:::::::",course_id)
    },
    async completeUnitStart() {
      this.disable_submit = true;
      console.log(document.getElementById("instructor").value);
        const instructorIds = this.selectedInstructors.map(Number); 

      await axios
        .put(
          `${process.env.VUE_APP_API}/categoryinstructorupdate/${this.changeInstructorPopup}/?Key=${this.userInfo.token_key}`,
          {
            id: this.changeInstructorPopup,
            instructor: instructorIds,
          }
        )
        .then((response) => {
          if (response.data.status == "200") {
            this.messages = {
              text: "Instructor Changed Successfully.",
              type: "success",
            };
            setTimeout(() => {
              // this.selectedInstructors=[];
              this.$refs.changeInsRef.reset();
              this.getCourses(1);
              this.changeInstructorPopup = null;
              this.messages = {
                text: "",
                type: "",
              };
            }, 2000);
          } else {
            this.messages = {
              text: "Error Issue.",
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "",
              };
            }, 2000);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.disable_submit = false;
        });
    },

    getInstructorList() {
      axios
        .get(
          `${process.env.VUE_APP_API}/instructor_all/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          console.log(res);
          this.instructor_lists = res.data.products;
        });
    },

    sectionsGet() {
      let department_id = document.getElementById("department_id").value;
      let program_id = document.getElementById("program_id").value;
      let semester_id = document.getElementById("semester_id").value;

      axios
        .get(
          `${process.env.VUE_APP_API}/section-list/?Key=${this.userInfo.token_key}&department_id=${department_id}&program_id=${program_id}&semester_id=${semester_id}`
        )
        .then((res) => {
          this.sections = res.data.data;
        });
    },
    coursetypeGet() {
      let department_id = document.getElementById("department_id").value;
      let program_id = document.getElementById("program_id").value;
      let semester_id = document.getElementById("semester_id").value;
      let section_id = document.getElementById("section_id").value;

      axios
        .get(
          `${process.env.VUE_APP_API}/course_type/?Key=${this.userInfo.token_key}&department_id=${department_id}&program_id=${program_id}&semester_id=${semester_id}&section=${section_id}`
        )
        .then((res) => {
          this.course_types = res.data.data;
        });
    },
    instructorGet() {
      let department_id = document.getElementById("department_id").value;
      let program_id = document.getElementById("program_id").value;
      let semester_id = document.getElementById("semester_id").value;
      let section_id = document.getElementById("section_id").value;
      let coursetype_id = document.getElementById("coursetype_id").value;
      axios
        .get(
          `${process.env.VUE_APP_API}/instructor-filterset-get/?Key=${this.userInfo.token_key}&course_type=${coursetype_id}&department_id=${department_id}&program_id=${program_id}&semester_id=${semester_id}&section=${section_id}`
        )
        .then((res) => {
          this.instructor_list = res.data.data?.filter(
            (item) => item.display_name != null
          );
          console.log("instructor_list", this.instructor_list);
        });
    },
    getPrograms() {
      axios
        .get(
          `${process.env.VUE_APP_API}/program-list/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          this.programs = res.data.data;
        });
    },
    getProgramsFilter() {
      this.courselist = [];

      let program_id = document.getElementById("program_id").value;
      // console.log(index);
      axios
        .get(
          `${process.env.VUE_APP_API}/department-list/?Key=${this.userInfo.token_key}&program__id=${program_id}`
        )
        .then((res) => {
          // this.departments = res.data.data;
          this.departments = res.data.data;
        });

      axios
        .get(
          `${process.env.VUE_APP_API}/courses/?program_id=${program_id}&Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.message == "No courses details") {
            console.log("Null");
          } else {
            this.totalPages = response.data.data.total_page;
            this.courselist = response.data.data.data.data;
            this.loading = false;
          }
        });
    },

    getSemesterFilter() {
      this.courselist = [];

      let batch_year = 1;
      let department_id = document.getElementById("department_id").value;
      // console.log(index);
      axios
        .get(
          `${process.env.VUE_APP_API}/semetser-get/?Key=${this.userInfo.token_key}&department__id=${department_id}&batch__id=${batch_year}`
        )
        .then((res) => {
          // this.semetser_list = res.data.data;
          this.semetser_list = res.data.data;
        });

      let program_id = document.getElementById("program_id").value;

      axios
        .get(
          `${process.env.VUE_APP_API}/courses/?department_id=${department_id}&program_id=${program_id}&Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.message == "No courses details") {
            console.log("Null");
          } else {
            this.totalPages = response.data.data.total_page;
            this.courselist = response.data.data.data.data;
            this.loading = false;
          }
        });
    },

    // getSemesterFilterCourse() {
    //   this.courselist = [];

    //   let department_id = document.getElementById("department_id").value;
    //   let program_id = document.getElementById("program_id").value;
    //   let semester_id = document.getElementById("semester_id").value;

    //   axios
    //     .get(
    //       `${process.env.VUE_APP_API}/courses/?department_id=${department_id}&program_id=${program_id}&semester_id=${semester_id}&Key=${this.userInfo.token_key}`
    //     )
    //     .then((response) => {
    //       if (response.data.message == "No courses details") {
    //         console.log("Null");
    //       } else {
    //         this.totalPages = response.data.data.total_page;
    //         this.courselist = response.data.data.data.data;
    //         this.loading = false;
    //       }
    //     });
    // },

    // getFilter() {
    //   this.loading = true;
    //   let department_id = document.getElementById("department_id").value;
    //   let program_id = document.getElementById("program_id").value;
    //   let semester_id = document.getElementById("semester_id").value;
    //   let section_id = document.getElementById("section_id").value;
    //   let coursetype_id = document.getElementById("coursetype_id").value;
    //   let instructor_id = document.getElementById("instructor_id").value;
    //   let instructor_name = document.getElementById("instructor_name").value;

    //   axios
    //     .get(
    //       `${process.env.VUE_APP_API}/courses/?dep_id=${department_id}&program_id=${program_id}&semester_id=${semester_id}&section=${section_id}&course_type=${coursetype_id}&instructor_email=${instructor_id}&instructor_name=${instructor_name}&Key=${this.userInfo.token_key}`
    //     )
    //     .then((response) => {
    //       if (response.data.status == 200) {
    //         this.totalPages = response.data.data.total_page;
    //         this.courselist = response.data.data.data.data;
    //         this.course_count = response.data.data.total;
    //  setTimeout(() => {
    //    this.loading = false;
    //  }, 600);
           
    //       } else if (response.data.status == 400) {
    //         this.courselist = [];
    //         this.course_count = 0;
    //       }
    //     });
    // },

    getInstructorListByFilter() {
      let department_id = document.getElementById("department_id").value;
      axios
        .get(
          `${process.env.VUE_APP_API}/instructor_all/?Key=${this.userInfo.token_key}&department__id=${department_id}`
        )
        .then((res) => {
          console.log(res);
          // this.instructor_lists = res.data.products;
          this.instructor_lists = res.data.products;
        });
    },

    closeReciveEmitAddUnit() {
      this.addLessonUnitPopup = false;
    },

   

    async getCourses(page) {
       this.currentPage = page;
       let department_id = document.getElementById("department_id")?.value || "";
      let program_id = document.getElementById("program_id")?.value || "";
      let semester_id = document.getElementById("semester_id")?.value || "";
      let section_id = document.getElementById("section_id")?.value || "";
      let coursetype_id = document.getElementById("coursetype_id")?.value || "";
      let instructor_id = document.getElementById("instructor_id")?.value || "";
      let instructor_name = document.getElementById("instructor_name")?.value || "";
      await axios
        .get(
          `${process.env.VUE_APP_API}/courses/?page=${page}&dep_id=${department_id}&program_id=${program_id}&semester_id=${semester_id}&section=${section_id}&course_type=${coursetype_id}&instructor_email=${instructor_id}&instructor_name=${instructor_name}&Key=${this.userInfo.token_key}&search=${this.search_list}`
        )
        .then((response) => {
            const res = response.data;
          if (res.status == 200) {
            this.totalPages = res.data.total_page;
             this.current_page = res.data.current_page;
            this.courselist = res.data.data.data;
            this.selectedInstructors = this.courselist;
            console.log(" this.selectedInstructors///", this.courselist[0].instructor.id)

            this.course_count = res.data.total;
            this.loading = false;

            console.log(
              res.data.total_page,
              "res.data.data.data.total_page"
            );
          } else if (res.status == 400) {
            console.log("42323");
            this.course_count = 0;
            this.courselist = [];
          }
        })
        .catch((err) => {
          console.log("error", err);
           this.course_count = 0;
      this.courselist = [];
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 600);
        });
    },

    async DuplicateCourse(course_id) {
      await axios
        .get(
          `${process.env.VUE_APP_API}/courseduplicate/${course_id}/?Key=${this.userInfo.token_key}`,
          {}
        )
        .then((response) => {
          if (response.data.status == 200) {
            
            
            this.messages = {
              text: "Course Duplicated",
              type: "success",
            };

            setTimeout(() => {
              this.getCourses(1);
              this.messages = {
                text: "",
                type: "",
              };
            }, 2000)

            // setTimeout(() => {
            //   axios
            //     .get(
            //       `${process.env.VUE_APP_API}/courses/?instructor=${this.instructorInfo.id}&Key=${this.userInfo.token_key}`
            //     )
            //     .then((response) => {
            //       if (response.data.message == "No courses details") {
            //         console.log("Null");
            //       } else {
            //         this.courselist = response.data.data;

            //         this.courselist.forEach((element) => {
            //           element.displayprice = new Intl.NumberFormat("hi-IN", {
            //             style: "currency",
            //             currency: "INR",
            //             maximumFractionDigits: 0,
            //           }).format(element.price);
            //         });
            //       }
            //     });

            //   this.messages = {
            //     text: "",
            //     type: "",
            //   };
            // }, 1000);
          } else {
            console.log("Course Duplicated Failed");
            this.messages = {
              text: " Course Duplicated Failed",
              type: "error",
            };
          }
        });
    },

    async deletecourse(data) {
      await axios
        .delete(
          `${process.env.VUE_APP_API}/courseupdate/${data}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          this.res = response;
          if (this.res.statusText == "No Content") {
            this.messages = {
              text: "Deleted successfully",
              type: "success",
            };
            console.log("successfull");
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        });
      this.popupwindow = false;
      setTimeout(() => {
        // this.getCourses();
        this.$router.go(0);
        this.messages = {
          text: "",
          type: "null",
        };
      }, 2000);
    },

//     async searchUserValue() {
//   this.disable_submit = true;
//   try {
//     const response = await axios.get(
//       `${process.env.VUE_APP_API}/courses/?search=${this.search_list}&Key=${this.userInfo.token_key}`
//     );

//     const resData = response.data?.data?.data || response.data?.data || response.data; // fallback

//     if (resData.status === 200) {
//       this.totalPages = resData.total_page || 0;
//       this.current_page = resData.current_page;
//       this.courselist = resData.data || [];
//       this.selectedInstructors = this.courselist;
//       this.course_count = resData.total || 0;
//       this.loading = false;

//       console.log(this.totalPages, "total_page");
//     } else if (response.data.status === 400) {
//       this.course_count = 0;
//       this.courselist = [];
//     }
//   } catch (err) {
//     console.log("error", err);
//   } finally {
//     this.disable_submit = false;
//   }
// },
    async filterorder() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/courses/?ordering=${this.selected_filter}&Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.message == "No courses details") {
            console.log("Null");
          } else {
            this.totalPages = response.data.data.total_page;
             this.current_page = response.data.data.current_page;
            this.courselist = response.data.data.data.data;
            this.loading = false;
          }
        });
    },
    clearFilters() {
      document.getElementById("program_id").value = "";
      document.getElementById("department_id").value = "";
      document.getElementById("semester_id").value = "";

      document.getElementById("section_id").value = "";
      document.getElementById("coursetype_id").value = "";
      document.getElementById("instructor_id").value = "";
      document.getElementById("instructor_name").value = "";

      this.selected_filter = "";
      this.search_list = "";
      this.getCourses(this.currentPage);
    },
  },
};
</script>

<style></style>
